



















































































import {
  ConfigurationItem,
  IConfigurationItem
} from '@/models/configurator/configuration';

import mixins from '@/utils/mixins';
import functions from '@/mixins/functions';
import { PropType } from 'vue';
import { mapActions } from 'vuex';
import { roundCurrency } from '@/utils/helpers';
import { cloneDeep } from 'lodash';

export default mixins(functions).extend({
  props: {
    item: Object as PropType<ConfigurationItem>,
    exchangeRate: Number,
    currencyCode: String
  },

  data: () => ({
    quantityErrors: [] as string[],
    quantityLoading: false
  }),

  computed: {
    subTotal(): number {
      return (
        roundCurrency(this.item.unit_price! * this.exchangeRate) *
        this.item.quantity!
      );
    }
  },

  methods: {
    roundCurrency,

    ...mapActions({
      updateConfigurationItem:
        'configuratorConfiguration/updateConfigurationItem'
    }),

    itemDetailClass(item: IConfigurationItem) {
      if (item.is_obsolete) {
        return 'item-row--disabled';
      }
    },

    deleteItem(item: IConfigurationItem) {
      this.$emit('deleteItem', item);
    },

    updateItem(item: IConfigurationItem) {
      this.$emit('updateItem', item);
    },

    debounceQuantity(quantity: number) {
      // clear errors without waiting for debounce
      this.quantityLoading = true;
      this.quantityErrors = [];

      // Call updateQuantity 1 second the last time this function is called
      return this.debounce(this.updateQuantity, 2000)(quantity);
    },

    async updateQuantity(quantity: number) {
      const validateQuantity = (value: number) => {
        if (value > 0) {
          return true;
        } else {
          this.quantityErrors.push('Quantity is not valid');

          throw Error('');
        }
      };

      // doing api store callback here to have easier access to loading
      try {
        // validate quantity should be from rules?
        validateQuantity(quantity);

        // Work-around - LH-2022-09-23- Need to delete description
        //  - to ensure configurable item description is translatable
        const itemClone = cloneDeep(this.item);
        delete itemClone.description;

        await this.updateConfigurationItem(itemClone).then(() => {
          // just emit the updateQuantity on success
          this.$emit('updateQuantity', itemClone);
        });
      } catch (e) {
        this.quantityErrors.push('Error updating quantity');
      } finally {
        this.quantityLoading = false;
      }
    }
  }
});
